import React, { Component } from "react";


export default class Tutorial extends Component {
    // constructor(props) {
    //     super(props);
    // }


    render() {
        return (
        <p class="lead text-left">tutorial Component</p>
        );
      }

}